module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Duggingen-dc62c6db0ae48daafe5882b04d88d5d8.png";